import React from "react";

const SvgFilterMale = props => (
  <svg
    viewBox="0 0 128 128"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    {...props}
  >
    <path
      d="M14.061 106.822c4.587-2.294 9.396-3.478 14.206-4.81 5.623-1.553 11.32-2.885 16.721-5.253 2.441-1.11 4.439-2.515 4.957-5.401.444-2.367-.074-4.513-1.924-6.067-6.511-5.401-9.47-12.726-11.468-20.642-.222-.814-.518-1.48-1.11-2.146-3.329-4.143-5.475-8.805-5.697-14.132-.074-1.627.444-3.181 1.924-4.143.666-.444.444-.888.296-1.406-1.776-7.768-1.702-15.389 2.146-22.566C40.622 7.974 50.093 3.757 62.893 4.571c5.993.37 11.912 1.553 17.979 1.701 2.071.074 4.069-.074 6.067-.961 1.627-.74 2.959-1.776 3.921-3.33 1.036-1.628 1.628-1.628 2.516.074 3.403 6.289 3.847 12.726.813 19.237-.37.814-.444 1.48-.222 2.368 1.258 6.288 1.924 12.651.74 19.014-.074.444-.296.962.444 1.258 2.516.888 3.256 3.626 2.738 6.363-.888 4.661-3.108 8.657-6.289 12.208-.518.592-.888 1.184-1.11 1.998-1.48 6.067-3.699 11.838-7.621 16.869-1.109 1.406-2.367 2.589-3.625 3.773-3.625 3.478-2.812 8.731 1.628 11.024 5.919 3.034 12.504 4.366 18.792 6.215 4.366 1.258 8.805 2.368 12.948 4.366 1.702.813 1.702.887.37 2.145-10.95 9.545-23.602 15.686-38.029 17.609-21.901 2.886-41.359-2.811-58.303-16.943-.813-.666-1.553-1.406-2.293-2.072 0-.222-.074-.37-.296-.665"
      fill="fill"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgFilterMale;
